import UserGarage from './UserGarage'
import userGarageContainer from './userGarageContainer'

export default userGarageContainer(UserGarage)
